import eventBus from "../../../../main";
import apiServices from "../../../../../services/apiServices";

export default {
  state: {
    localProduct: {
      allProduct: Array,
      allCategoryProduct: Array
    }
  },
  mutations: {
    SET_ALL_PRODUCT(state, value) {
      state.localProduct.allProduct = value;
    },
    SET_ALL_C_CATEGORY_PRODUCT(state, value) {
      state.localProduct.allCategoryProduct = value;
    }
  },
  actions: {
    displayAllProduct(context, payload) {
      apiServices
        .getProductsToView(payload)
        .then(function(response) {
          if (response.status === 200 || response.status === 300) {
            let obj = response.data;
            context.commit("SET_ALL_PRODUCT", obj.message);
          } else {
            let payload = {
              color: "info",
              text: "Não há dados disponíveis",
              errorLogin: true,
              right: "center",
              top: "top"
            };
            eventBus.$emit("openInfo", payload); // emit the event to the bus
          }
        })
        .catch(function(error) {
          let payload = {
            color: "error",
            text: "Ups! Seu pedido não foi processado",
            errorLogin: true,
            right: "center",
            top: "top"
          };
          if (error == "Error: Network Error") {
            return eventBus.$emit("openInfo", {
              color: "error",
              text: "Verifique a sua conexão com a internet",
              errorLogin: true,
              right: "center",
              top: "top"
            }); // emit the event to the bus
          }

          eventBus.$emit("openInfo", payload); // emit the event to the bus
        })
        .finally(function() {
          eventBus.$emit("openSpin", false);
        });
    },
    displayAllProductCategory(context, payload) {
      eventBus.$emit("openSpin", true);
      apiServices
        .getCategoryToView(payload.productCategoryUUID)
        .then(function(response) {
          if (response.status === 200 || response.status === 300) {
            let obj = response.data;
            context.commit("SET_ALL_C_CATEGORY_PRODUCT", obj.message);
            eventBus.$emit("listCProductCategory", payload); // emit the event to the bus
          } else {
            let payload = {
              color: "error",
              text: "Ups! Seu pedido não foi processado",
              errorLogin: true,
              right: "center",
              top: "top"
            };
            eventBus.$emit("openInfo", payload); // emit the event to the bus
          }
        })
        .catch(function(error) {
          let payload = {
            color: "error",
            text: "Ups! Seu pedido não foi processado",
            errorLogin: true,
            right: "center",
            top: "top"
          };
          if (error == "Error: Network Error") {
            return eventBus.$emit("openInfo", {
              color: "error",
              text: "Verifique a sua conexão com a internet",
              errorLogin: true,
              right: "center",
              top: "top"
            }); // emit the event to the bus
          }

          eventBus.$emit("openInfo", payload); // emit the event to the bus
        })
        .finally(function() {
          eventBus.$emit("openSpin", false);
        });
    }
  },
  getters: {
    getProductToDisplay(state) {
      return state.localProduct.allProduct;
    },
    getAllCategoryProductToDisplay(state) {
      return state.localProduct.allCategoryProduct;
    }
  }
};
